<template>
  <richtext-fi
    class="product-benefits-item-fi"
    field-name="description"
  />
</template>

<script setup lang="ts">
import { RichtextFi } from 'atoms';
</script>

<style scoped src="./product-benefits-item-fi" />
